import { Box, BoxProps, Grid, Typography, TypographyProps } from '@alice-financial/pretext-ui'
import * as React from 'react'

export const QuestionText = ({ children, required }: { children: React.ReactNode; required?: boolean }) => (
  <Typography variant="body2" fontWeight="bold" lineHeight={1.5}>
    {children}
    {required && (
      <Typography color="error" variant="caption" fontWeight="bold">
        {' '}
        *
      </Typography>
    )}
  </Typography>
)
export const QuestionSubtext = (props: TypographyProps) => (
  <Typography variant="body2" component="p" color="text.secondary" {...props} />
)
export const QuestionContainer = (props: BoxProps) => (
  <Box sx={(theme) => ({ '&:not(:last-child)': { marginBottom: theme.spacing(4) } })} {...props} />
)

export const QuestionPageDescription = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" gutterBottom>
    {children}
  </Typography>
)
export const QuestionPageHeading = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="h2" gutterBottom>
    {children}
  </Typography>
)

type UserInputsProps = {
  name: React.ReactNode
  email: React.ReactNode
  phone?: React.ReactNode
  company?: React.ReactNode
}
export const UserInputs = ({ name, email, phone, company }: UserInputsProps) => (
  <Grid container spacing={2}>
    <Grid size={{ xs: 12, md: 6 }}>{name}</Grid>
    {company && <Grid size={{ xs: 12, md: 6 }}>{company}</Grid>}
    <Grid size={{ xs: 12, md: 6 }}>{email}</Grid>
    {phone && <Grid size={{ xs: 12, md: 6 }}>{phone}</Grid>}
  </Grid>
)
